import { getCookie } from 'cookies-next';
import { hasRefreshToken } from './auth-interceptor-shared';
import { readWebinappToken } from './webinapp-token';

/**
 * Read AhaFood auth token from `token` cookie.
 * Returns empty string nếu không có (matches existing callsite expectations).
 *
 * Webinapp session (KHÔNG có `refresh_token` — chỉ web OAuth login mới set nó) →
 * trả token CHÍNH đã persist (token URL bền), KHÔNG đọc cookie `token` nhập nhằng
 * (có thể là token cũ/cross-account → ~16 callsite gửi token sai trong header lẫn
 * body request). Web bình thường giữ nguyên hành vi đọc cookie.
 */
export function getAuthToken(): string {
  if (!hasRefreshToken()) {
    const webinappToken = readWebinappToken();
    if (webinappToken) return webinappToken;
  }
  const token = getCookie('token');
  if (typeof token === 'string' && token) return token;
  return '';
}

/**
 * Same as getAuthToken but returns null instead of empty string.
 * Use for `enabled: !!token` patterns.
 */
export function getAuthTokenOrNull(): string | null {
  const t = getAuthToken();
  return t || null;
}
